import { AnchorHTMLAttributes, ElementType, ReactNode } from 'react';
import styled from 'styled-components';
import { BaseStyleProps, base, themed } from '../base';

export interface LinkProps
  extends BaseStyleProps,
    Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'color'> {
  as?: ElementType;
  children?: ReactNode;
}

/* eslint-disable @typescript-eslint/no-explicit-any */
const LinkWrapper = styled('a')<LinkProps>(
  { textDecoration: 'none', alignItems: 'center' },
  base as any,
  themed('Link') as any
);
/* eslint-enable @typescript-eslint/no-explicit-any */

const Link = ({
  as = 'a',
  m = 0,
  display = 'inline-flex',
  children,
  ...props
}: LinkProps) => (
  <LinkWrapper as={as} m={m} display={display} {...props}>
    {children}
  </LinkWrapper>
);

export default Link;
